import {
	AGENDA_LIST_GENERIC_ACTIVITY_LIST_SORT,
	AGENDA_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/appointmentModuleSearch/localStorageKeys';
import { TSMap } from 'typescript-map';

import { FilterListItem } from 'src/models/filterList';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';

interface AppointmentModuleSearchStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	resultsAll: Array<FilterListItem>;
	resultsAllSliced: Map<number, Array<FilterListItem>>;
	resultsAllTotalCount: number;
	resultsMine: Array<FilterListItem>;
	resultsMineSliced: Map<number, Array<FilterListItem>>;
	resultsMineTotalCount: number;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
}

const paginationEntry = (): GenericActivityListPagination => ({
	page: 1,
	rowsPerPage: 100,
});

function createAppointmentModuleSearchState(): AppointmentModuleSearchStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
		]),
		dateTimeRangeFilter: PreconfiguredTimeRanges.ALL,
		listViewModeLarge:
			localStorage.getItem(AGENDA_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(AGENDA_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, paginationEntry()],
			[ActivityListTypeEnum.MINE, paginationEntry()],
		]),
		resultsAll: [],
		resultsAllSliced: new Map<number, Array<FilterListItem>>(),
		resultsAllTotalCount: 0,
		resultsMine: [],
		resultsMineSliced: new Map<number, Array<FilterListItem>>(),
		resultsMineTotalCount: 0,
		sort:
			localStorage.getItem(AGENDA_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(AGENDA_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[ActivityListTypeEnum.ALL, { direction: 'DESC', property: 'timestamp' }],
						[ActivityListTypeEnum.MINE, { direction: 'DESC', property: 'timestamp' }],
					]),
	};
}

export default createAppointmentModuleSearchState;
